import { createAction, props } from '@ngrx/store';
import { CropField } from 'src/app/shared/models';

import {
  ManureSpaceSettings,
  ManureSpaceSettingToggles,
  PostManureSpaceSettingsData,
} from '../models/manure-space-settings.models';

export const openFieldsDialog = createAction('[CropField] Open fields dialog');

export const loadCropFieldsRequest = createAction('[CropField] Load CropFields request');
export const loadCropFieldsSuccess = createAction(
  '[CropField] Load CropFields success',
  props<{ cropFields: CropField[] }>(),
);

export const getManureSpaceSettingsRequest = createAction(
  '[CropField] Get manure space settings request',
  props<{ manureSpaceId: number }>(),
);
export const getManureSpaceSettingsSuccess = createAction(
  '[CropField] Get manure space settings success',
  props<{ settings: ManureSpaceSettings[] }>(),
);

export const getManureSpaceSettingTogglesRequest = createAction(
  '[CropField] Get manure space settings toggles request',
);
export const getManureSpaceSettingTogglesSuccess = createAction(
  '[CropField] Get manure space settings toggles success',
  props<{ settingToggles: ManureSpaceSettingToggles[] }>(),
);

export const postManureSpaceSettingRequest = createAction(
  '[CropField] Post manure space settings request',
  props<{ manureSpaceSettingsData: PostManureSpaceSettingsData }>(),
);

export const postManureSpaceSettingSuccess = createAction(
  '[CropField] Post manure space settings success',
);
